interface IDocBaseInfo {
    version: string;
    updateTime: number;
    docUrl: string;
    docId: string;
    updater: string;
    title: string;
    createTime: number;
    creator: string;
}

export interface ISideBarItem {
    docUrl: string;
    docId: string;
    parentDocId: string;
    isLeaf: boolean;
    title: string;
    children?: ISideBarItem[];
}

export enum DOC_MODE {
    preview = 'preview',
    edit = 'edit',
    meeting = 'meeting',
    history = 'history',
}

interface IDocPermission {
    isAdmin: boolean;
    isMember: boolean;
    isReader: boolean;
    isPublic: boolean;
    isPublicEdit: boolean;
}

interface ISerializeOptions {
    // 内联序列化时，采用了em相对字体，配置是否继承使用方父节点的字体大小，默认使用了16px的根大小
    inheritFontSize?: boolean;
}

interface IDocContentOption {
    type: 'json' | 'markdown' | 'text' | 'html';
    brCharacterInTable?: string;
    inlineStyle?: boolean;
}

export interface IAttachItem {
    id: string; // 附件id
    url: string; // 下载地址
    type: string; // 附件类型
    size: number; // 附件大小
    name: string; // 附件名
    extension: string; // 附件后缀
}

export interface IDoc {
    [key: string]: any;
    getDocContent: (options: IDocContentOption) => Promise<any>;
    getDocBaseInfo: () => IDocBaseInfo;
    getSideBarData: () => ISideBarItem[];
    getDocPermission: () => IDocPermission;
    getDocMode: () => DOC_MODE;
    getDocStaticHtml: (options?: ISerializeOptions) => string;
    getDocAttachData: () => Promise<IAttachItem[]>;
    getDocToken: () => string;
    getIsDemoMode: () => boolean;
}
